"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Definition of the parseObject utility
 * @author Harris Lummis
 */

var changeCase_1 = require("@atlas/models/utils/changeCase");

var mapKeys_1 = __importDefault(require("lodash/mapKeys"));
/**
 * Parses an object and creates a new instance of the provided class using it
 * @param Class The class constructor used to create the parsed instance
 * @param obj The object to parse
 * @return A new instance of the class created using the provided object in
 * camelCase as properties
 */


function parseObject(Class, obj) {
  return new Class(mapKeys_1.default(obj, function (_v, k) {
    return changeCase_1.camelCase(k);
  }));
}

exports.parseObject = parseObject;